<template>
  <div class="container position-sticky position-top-0 zindex-4 bg-white pb-1 mb-2 shadow">
    <div class="row">
      <div class="col-12">
        <b-badge variant="light-warning mb-1">
          ACT-{{ activity.id }}
        </b-badge>
        <b-badge variant="light-primary float-right">
          {{ activity.createdAt | dateFormat }}
        </b-badge>
        <br />
        <b-badge variant="light-primary">
          {{ activity.referenceElementType }}
        </b-badge>
        <b-badge v-if="activity.referenceId" variant="light-success" class="ml-3">
          #
          <feather-icon icon="FileTextIcon" />
          {{ activity.referenceElementNumber }}
        </b-badge>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    activity: { type: Object, default: () => {} }
  }
};

</script>
